import styled from 'styled-components';
import { palette } from '../../theme/colors';

/*
  Separate wrappers for asymmetrical border radius to eliminate a border rendering glitch
  (https://github.com/facebook/react-native/issues/34048 — same idea applied here for consistency
  with the mobile implementation).
 */
export const Outer = styled.div`
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  overflow: hidden;
`;

export const Inner = styled.div`
  background-color: ${palette.darkGold};
  border-left: 3px solid ${palette.gold};
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Label = styled.p`
  color: ${palette.gold};
  font-family: 'Roboto-Bold';
  font-size: 14px;
  line-height: 20px;
  margin: 0;
`;

export const Body = styled.p`
  color: ${palette.white};
  font-family: 'Roboto-Regular';
  font-size: 13px;
  line-height: 18px;
  margin: 0;
`;
